import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortenText',
  standalone: false,
})
export class ShortenLongTextPipe implements PipeTransform {
  transform(text: string, size: number): string {
    const textLength = size === 0 ? 30 : size;

    if (text?.length > textLength) {
      return text.slice(0, textLength) + '...';
    }
    return text;
  }
}
